<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>

      <v-card-text>
        <v-row class="pt-2" align-content="center">
          <v-col cols="5" md="2">
            <TextFieldInput :label="$t('ELE0031')" v-model="searchCondition.partCd" />
          </v-col>
          <v-col cols="7" md="3">
            <TextFieldInput :label="$t('ELE0032')" v-model="searchCondition.partName" />
          </v-col>
          <v-col cols="9" md="5">
            <JudgeMultipleInput :label="$t('ELE0181')" required v-model="searchCondition.judge" />
          </v-col>
          <v-col cols="3" md="2" class="d-flex align-center justify-end">
            <BtnSearch @click="onClickSearch" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title class="pt-1 pb-0">
                {{ $t('ELE0023') }}
              </v-card-title>
              <v-data-table :headers="headers" :items="items" dense>
                <template v-slot:header>
                  <thead>
                    <tr>
                      <th class="top-headers" colspan="2">{{ $t('ELE0001') }}</th>
                      <th class="top-headers" colspan="2">{{ $t('ELE0260') }}</th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:[`item.partCd`]="{ item }">
                  <a href="#" @click="onPartCdClick(item.topicsPartCd)" @href.stop.prevent="">
                    {{ item.partCd }}
                  </a>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import JudgeMultipleInput from '@/components/atoms/select/JudgeMultipleInput.vue'
import { PartJudge } from '@/enum'

export default {
  name: 'CompanyForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    TextFieldInput,
    BtnSearch,
    JudgeMultipleInput,
  },

  data() {
    return {
      searchCondition: {
        partCd: '',
        partName: '',
        judge: [PartJudge.DIFFERENT_NAMES, PartJudge.EC_UP],
      },
      headers: [
        { text: this.$t('ELE0031'), divider: true, value: 'partCd' },
        { text: this.$t('ELE0032'), divider: true, value: 'partName' },
        { text: this.$t('ELE0031'), divider: true, value: 'topicsPartCd' },
        { text: this.$t('ELE0032'), divider: true, value: 'topicsPartName' },
        { text: this.$t('ELE0181'), divider: false, value: 'judge' },
      ],
      items: [],
    }
  },

  methods: {
    onPartCdClick(partCd) {
      this.$router.push({ name: 'M02', query: { partCd: partCd } }).catch(() => {})
    },
    getJudge(judge) {
      const judgeValue = judge?.split(',')
      if (judgeValue?.length > 0) {
        const judgeTextArray = judgeValue.map((element) => {
          return this.$t(`PartJudge.${element}`)
        })
        return judgeTextArray?.join(', ')
      }
    },
    async onClickSearch() {
      this.startLoading()

      try {
        const data = await API.get('/topics/latest-parts', this.searchCondition)
        if (data) {
          this.items = data.map((item) => {
            return {
              partCd: item.partCd,
              partName: item.partName,
              topicsPartCd: item.topicsPartCd,
              topicsPartName: item.topicsPartNameE,
              judge: this.getJudge(item.judge),
            }
          })
        }
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0261') })))
      } finally {
        this.stopLoading()
      }
    },
  },
  mounted() {
    // this.onClickSearch()
  },
}
</script>

<style>
.top-headers {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
</style>
